import { DataStoreFactory } from 'services/DataStore/DataStore';

const dsFactory = new DataStoreFactory();
export const dcbsDataStore = dsFactory.create();
